<div class="flex items-center justify-start gap-4 mb-6">
  <h2 class="text-xl font-semibold">Beni da Assicurare</h2>
  <button
    class="bg-blue-600 text-white font-semibold px-4 py-2 rounded shadow hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="avantiStep()"
    [disabled]="voci.length === 0"
  >
    Avanti >>
  </button>
</div>

<div class="mb-10">

  <div>
    <p class="mb-6">
      Aggiungi i veicoli o le patenti che vuoi assicurare, fino a un massimo di 40. Puoi cambiare il massimale che è valido per tutti i beni inseriti.
    </p>

    <!-- Campo massimale -->
    <div class="mb-6">
      <label class="block font-medium mb-2">Massimale (valido per tutte le voci)</label>
      <select
        [(ngModel)]="massimale"
        name="massimale"
        required
        class="w-44 border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      >
        <option [value]="25000">25.000</option>
        <option [value]="50000">50.000</option>
        <option [value]="100000">100.000</option>
        <option [value]="150000">150.000</option>
      </select>
    </div>

    <div>
      <button
        class="bg-green-600 text-white font-semibold px-6 py-2 rounded shadow hover:bg-green-700"
        (click)="apriPopupNuovaVoce()"
      >
        Aggiungi Bene
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="mostraPopup && nuovaVoce"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
<form #form="ngForm">
  <div class="border border-gray-300 rounded-lg p-6 shadow bg-gray-50">
    <h3 class="text-lg font-semibold mb-6">Nuovo Bene</h3>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Colonna 1 -->
      <div>
        <label class="block font-medium mb-1">Etichetta (opzionale)</label>
        <input
          type="text"
          [(ngModel)]="nuovaVoce.etichetta"
          name="etichetta"
          class="w-full border border-gray-300 rounded px-3 py-2"
        />

        <label class="block font-medium mt-4 mb-1">Targa / N. Patente / Titolare patente</label>
        <input
          type="text"
          [(ngModel)]="nuovaVoce.targa"
          name="targa"
          required
          class="w-full border border-gray-300 rounded px-3 py-2"
        />

        <label class="block font-medium mt-4 mb-1">Tipo Patente</label>
        <select
          [(ngModel)]="nuovaVoce.tipoPatente"
          name="tipoPatente"
          required
          class="w-full border border-gray-300 rounded px-3 py-2"
        >
          <option value="Patente A o B">Patente A o B</option>
          <option value="Patente C - D o CQC">Patente C - D o CQC</option>
        </select>
      </div>

      <!-- Colonna 2 -->
      <div>
        <label class="block font-medium mb-1">Importo Diaria (€)</label>
        <select
          [(ngModel)]="nuovaVoce.diaria"
          name="diaria"
          required
          class="w-full border border-gray-300 rounded px-3 py-2"
        >
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="75">75</option>
          <option [value]="100">100</option>
          <option [value]="150">150</option>
          <option [value]="200">200</option>
        </select>

        <label class="block font-medium mt-4 mb-1">Numero Giorni Diaria</label>
        <select
          [(ngModel)]="nuovaVoce.giorni"
          name="giorni"
          required
          class="w-full border border-gray-300 rounded px-3 py-2"
        >
          <option [value]="90">90</option>
          <option [value]="180">180</option>
        </select>
      </div>
    </div>

    <!-- Azioni -->
    <div class="mt-6 flex gap-4">
      <button
        type="button"
        class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
        (click)="salvaNuovaVoce(); chiudiPopup()"
        [disabled]="!form.valid"
      >
        Salva
      </button>
      <button
        type="button"
        class="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
        (click)="nuovaVoce = null; chiudiPopup()"
      >
        Annulla
      </button>
    </div>
  </div>
</form>

</div>

<!-- Titolo elenco -->
<h3 class="text-lg font-semibold mb-4 text-gray-800">
  {{ voci.length > 0 ? 'Elenco beni da assicurare' : 'Nessun bene aggiunto' }}
</h3>

<!-- Elenco voci salvate -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
<ng-container *ngFor="let voce of voci; let i = index">
  <div class="border border-blue-900 rounded-md p-3 text-sm">
    <h4 class="font-semibold text-base mb-2 text-gray-800">
      {{ voce.etichetta || voce.targa }}
    </h4>
    <p><strong class="text-gray-600">Targa / N. Patente:</strong> {{ voce.targa }}</p>
    <p><strong class="text-gray-600">Tipo patente:</strong> {{ voce.tipoPatente }}</p>
    <p><strong class="text-gray-600">Massimale:</strong> {{ massimale | number:'1.0-0' }} €</p>
    <p><strong class="text-gray-600">Diaria:</strong> {{ voce.diaria }} € × {{ voce.giorni }} giorni</p>
    <p><strong class="text-gray-600">Coperture:</strong></p>
    <ul class="list-disc list-inside text-gray-700 mb-2">
      <li *ngFor="let c of voce.coperture">{{ c }}</li>
    </ul>

    <div class="mt-2">
      <button
        type="button"
        class="inline-flex items-center justify-center p-2 rounded-full border border-red-200
              text-red-600 hover:bg-red-50 hover:text-red-700 hover:border-red-300
              focus:outline-none focus:ring-2 focus:ring-red-400"
        (click)="rimuoviVoce(i)"
      >
        <!-- Icona cestino (Lucide Trash-2) -->
        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
          <path d="M10 11v6"></path>
          <path d="M14 11v6"></path>
          <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
        </svg>
      </button>
    </div>
  </div>
</ng-container>
</div>
